import { apiService, TopazResult, TopazSetupRequest } from '../..'

export const topazSetupService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    setupOrder: build.mutation<TopazResult, TopazSetupRequest>({
      query: (body) => ({
        url: '/topaz/paylater/order/setup',
        method: 'post',
        data: body,
      }),
    }),
    setupPayment: build.mutation<TopazResult, TopazSetupRequest>({
      query: (body) => ({
        url: '/topaz/paylater/payment/setup',
        method: 'post',
        data: body,
      }),
    }),
  }),
})
